import type { BusinessBlackoutDateInput, BusinessBlackoutDateRule } from '@/types/settings';

function toIso(year: number, month: number, day: number) {
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}

function nthWeekdayOfMonth(year: number, month: number, weekday: number, ordinal: number) {
  const first = new Date(year, month - 1, 1);
  const offset = (weekday - first.getDay() + 7) % 7;
  return 1 + offset + (ordinal - 1) * 7;
}

function lastWeekdayOfMonth(year: number, month: number, weekday: number) {
  const last = new Date(year, month, 0);
  const offset = (last.getDay() - weekday + 7) % 7;
  return last.getDate() - offset;
}

export function blackoutRuleDate(year: number, rule: BusinessBlackoutDateRule) {
  const day =
    rule.kind === 'lastWeekdayOfMonth'
      ? lastWeekdayOfMonth(year, rule.month, rule.weekday)
      : nthWeekdayOfMonth(year, rule.month, rule.weekday, rule.ordinal);
  const date = new Date(year, rule.month - 1, day + (rule.offsetDays ?? 0));
  return toIso(date.getFullYear(), date.getMonth() + 1, date.getDate());
}

function ruleKey(rule: BusinessBlackoutDateRule) {
  return [
    rule.kind,
    rule.month,
    rule.weekday,
    rule.kind === 'nthWeekdayOfMonth' ? rule.ordinal : 'last',
    rule.offsetDays ?? 0,
  ].join(':');
}

export function blackoutDateKey(entry: BusinessBlackoutDateInput) {
  if (typeof entry !== 'string' && entry.rule) return `rule:${ruleKey(entry.rule)}`;
  return typeof entry === 'string'
    ? `date:${entry}`
    : `${entry.annual ? 'annual' : 'date'}:${entry.annual ? entry.date.slice(5) : entry.date}`;
}

export function blackoutDateForYear(entry: BusinessBlackoutDateInput, year: number) {
  if (typeof entry !== 'string' && entry.rule) return blackoutRuleDate(year, entry.rule);
  if (typeof entry !== 'string' && entry.annual) return `${year}-${entry.date.slice(5)}`;
  return typeof entry === 'string' ? entry : entry.date;
}
